export default {
  download_list: 'Lista de descargas',
  upload_store: 'Subir tienda',
  reference_detail: 'Detalle del lote',
  submid: 'ID de sub-comercio',
  store_name: 'Nombre de la tienda',
  store_address: 'Dirección de la tienda',
  business_line: 'Línea de negocio',
  register_no: 'Número de registro',
  bank_ewallet_name: 'Nombre de banco/billetera electrónica',
  account_holder_name: 'Nombre del titular de la cuenta',
  bank_ewallet_no: 'Número de banco/billetera electrónica',
  download_qr: 'Descargar código QR',
  upload_store_attachments: 'Subir adjuntos de la tienda',
  qr_stand: 'QR Stand',
  qr_stand_id: 'ID de QR Stand',
  receipt: 'Recibo',
  edit_remark: 'Editar notas'
}
